import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="bg-[#C2A4D6]/10 p-4 rounded-lg mb-6">
        <p className="font-semibold">Your Privacy Matters</p>
        <p>We use industry-standard security measures to protect your conversations and personal information.</p>
      </div>

      <h4 className="text-lg font-semibold mb-2">Data Collection</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Conversation content and patterns</li>
        <li>Account and usage information</li>
        <li>Technical data for service improvement</li>
        <li>Payment information (processed securely)</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Data Usage</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Provision of requested services</li>
        <li>Personalization of responses</li>
        <li>Service optimization</li>
        <li>Anonymous aggregated analytics</li>
      </ul>
    </div>
  );
};

export default Privacy;